import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { ObjectifSpecifique } from 'src/app/shared/models/objectif_specifique';
import { Resultats } from 'src/app/shared/models/resultat';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-add-resultats',
  standalone: false,
  templateUrl: './add-resultats.component.html',
  styleUrl: './add-resultats.component.scss'
})

export class AddResultatsComponent {


  constructor(
    private modalService: NgbModal,

    private paramService: ParameterService,
    private messageService: MessageService,
    private FecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,



  ) {

  }

  ngOnInit() {
    this.getObjectif()
  }

  close() {

    this.modalService.dismissAll();
  }

  item: Resultats = new Resultats();
  programmeData: any = []
  agenceData: any = [];
  resultatItems: any = [];

  addObejectif() {

    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });

    } else {

      this.ngxService.start();

      let newItem = {
                      "code": this.item.code,
                      "libelle": this.item.libelle,
                      "objectifs_specifiques_id": this.item.objectifs_specifiques_id.id,
                  };

      this.paramService.addResultat(newItem).subscribe(
        (response: any) => {
          ////console.log("la reponse du webservice",response);

          this.modalService.dismissAll();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
          this.FecthDataService.notifySeriviceCreated();
          this.ngxService.stop();
        },
        (error: any) => {
          const errorMessage = error?.error?.message
            || error?.error?.error
            || error?.message
            || 'Une erreur est survenue';
          //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: errorMessage });
          this.FecthDataService.notifySeriviceCreated();
          this.ngxService.stop();


        }
      )
    }

  }

  getObjectif() {


    this.paramService.getObjectif().subscribe(

      (response: any) => {

        this.programmeData = response.data;

        ////console.log("this.programmeData",this.programmeData);
      },
      (error) => {
        ////console.log("une erreur est survenu",error);

      }

    );
  }

  onSelectObjectif(){

    this.item.code = this.item.objectifs_specifiques_id.code + '.'
  }
  getResultat() {
    this.paramService.getStatutRessource().subscribe(
      (response: any) => {
        //console.log("la réponse du webservice", response);
        this.resultatItems = response.data;
      },
      (error: any) => {
        //console.log("une erreur est survenu", error);

      }
    )
  }
}
